import { ifNumberValidThen, getReadableInteger, getNumberParts, roundDecimal, } from '../utils';
export function formatNumber(input, options) {
    var _a = (typeof options === 'object' && options) || {}, _precision = _a.precision, maxPrecision = _a.maxPrecision, _b = _a.decimalPoint, decimalPoint = _b === void 0 ? '.' : _b, separator = _a.separator, separatorPattern = _a.separatorPattern;
    var precision = _precision;
    if (typeof options !== 'object') {
        precision = options;
    }
    return ifNumberValidThen(input, function (number) {
        var originStr = roundDecimal(number, maxPrecision);
        var roundPrecision = ifNumberValidThen(maxPrecision, function (max) {
            return ifNumberValidThen(precision, function (p) { return Math.min(p, max); }, void 0);
        }, precision);
        originStr = roundDecimal(originStr, roundPrecision);
        if (!separator) {
            return originStr.replace(/\./, decimalPoint);
        }
        else {
            var _a = getNumberParts(originStr), symbol = _a.symbol, integer = _a.integer, decimal = _a.decimal;
            var integerPartWithSep = typeof separator === 'function'
                ? separator(integer)
                : getReadableInteger(integer, { separator: separator, separatorPattern: separatorPattern });
            return (symbol + integerPartWithSep + (decimal ? decimalPoint + decimal : ''));
        }
    }, '');
}
